import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";
import { EditExpenseFormValues } from "../components/ExpenseEditModal";

export const getExpenses = async (config?: AxiosRequestConfig) => {
  if (config?.params?.sort) {
    config.params.sort = JSON.stringify(config.params.sort);
  }

  if (config?.params?.filters) {
    config.params.filters = JSON.stringify(config.params.filters);
  }

  const { data } = await axiosInstance.get("/expenses", config);
  return data;
};

export const updateExpense = async (
  id: string,
  data: EditExpenseFormValues
) => {
  const { data: response } = await axiosInstance.put(`/expenses/${id}`, data);
  return response;
};

export const deleteExpense = async (id: string) => {
  const { data: response } = await axiosInstance.delete(`/expenses/${id}`);
  return response;
};

export const getExpenseType = async (id: string) => {
  const response = await axiosInstance.get(`/expenses/types/${id}`);
  return response.data;
};

export const getExpenseDescriptions = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/expenses/descriptions", config);
  return response.data;
};

export const getExpenseUnits = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/units", config);
  return response.data;
};

export const getExpenseSuppliers = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/suppliers", config);
  return response.data;
};

export const getExpenseHistories = async (config: AxiosRequestConfig) => {
  const response = await axiosInstance.get("/expenses", config);
  return response.data;
};
